import type { FC } from 'react';
import {
  Box,
} from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import React from 'react';
import QuoteCartAddonLeftPreview from "./QuoteCartAddonLeftPreview";
import { QuoteHr } from '../../quotePage/components/QuoteHr';
import { hasAddons, quateAddonQuantityValue } from '../../../app/utils';

interface QuoteCartAddonSelectedProps {
  className?: string;
  addons?: QuoteLineItem[];
  onRemoveAddon: (addon: QuoteLineItem) => void;
  onChangeQuantity: (addon: QuoteLineItem, quantity: number) => void;
}

const QuoteCartAddonSelected: FC<QuoteCartAddonSelectedProps> = ({
  addons,
  onRemoveAddon,
  onChangeQuantity
}) => {

  if (!hasAddons(addons)) {
    return null;
  }

  const addonView = function (addon: QuoteLineItem) {

    if (!addon) {
      return null;
    }

    return <Box
      key={addon.name + "cart-left-preview"}
    >
      <QuoteHr 
        mt={3}
        mb={3}
      />
      <QuoteCartAddonLeftPreview
        name={addon.name}
        image={addon.imageUrl}
        price={quateAddonQuantityValue(addon)}
        quantity={addon.quantity}
        addon={addon}
        onRemoveAddon={onRemoveAddon}
        onChangeQuantity={onChangeQuantity}
      />
    </Box>;
  };

  return <React.Fragment>
    {addons!
      .filter((v) => v.selected)
      .map((li) => addonView(li))}
  </React.Fragment>
};

export default QuoteCartAddonSelected;